import { CountryCode, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export type PhoneCountry = 'GB' | 'FR';

export function phoneCountryFromLocale(locale: string | undefined): PhoneCountry {
  return locale === 'fr-fr' ? 'FR' : 'GB';
}

interface PhoneCountryConfig {
  callingCode: string;
  invalidMessage: string;
}

export const PHONE_COUNTRY_CONFIG: Record<PhoneCountry, PhoneCountryConfig> = {
  GB: {
    callingCode: '+44',
    invalidMessage: 'Please enter a valid UK phone number',
  },
  FR: {
    callingCode: '+33',
    invalidMessage: 'Veuillez entrer un numéro de téléphone français valide',
  },
};

export function toLocalPhoneNumber(e164Value: string, country: PhoneCountry): string {
  if (!e164Value) return '';
  const prefix = PHONE_COUNTRY_CONFIG[country].callingCode;

  try {
    const parsed = parsePhoneNumber(e164Value, country as CountryCode);
    return parsed?.nationalNumber || e164Value.replace(prefix, '');
  } catch {
    return e164Value.replace(prefix, '');
  }
}

export function toE164PhoneNumber(localValue: string, country: PhoneCountry): string {
  if (!localValue) return '';
  const prefix = PHONE_COUNTRY_CONFIG[country].callingCode;
  const cleaned = localValue.replace(/\s/g, '').replace(/^0+/, '');
  return `${prefix}${cleaned}`;
}

export function validatePhoneNumber(value: string, country: PhoneCountry): string | true {
  if (!value) return true;
  if (!isValidPhoneNumber(value, country as CountryCode)) {
    return PHONE_COUNTRY_CONFIG[country].invalidMessage;
  }
  return true;
}

export function FranceFlagIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6" width="24" height="12" aria-hidden>
      <rect width="3" height="6" fill="#002395" />
      <rect x="3" width="3" height="6" fill="#fff" />
      <rect x="6" width="3" height="6" fill="#ED2939" />
    </svg>
  );
}

export function UkFlagIcon({ clipRectId, clipDiagId }: { clipRectId: string; clipDiagId: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="24" height="12" aria-hidden>
      <clipPath id={clipRectId}>
        <rect width="60" height="30" />
      </clipPath>
      <g clipPath={`url(#${clipRectId})`}>
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <clipPath id={clipDiagId}>
          <path d="M30,0 L60,0 L60,15 Z M30,30 L0,30 L0,15 Z M0,0 L0,10 L20,15 Z M60,30 L60,20 L40,15 Z" />
        </clipPath>
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          stroke="#C8102E"
          strokeWidth="4"
          clipPath={`url(#${clipDiagId})`}
        />
        <path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}
